import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {customerListURL} from "./customerTable.constants";

export const useCustomerSearchOptions = () => {
  const options = useSearchOptions(customerListURL, ["name"]);

  const searchOptions = [
    {
      category: {label: "Name", value: "name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.name,
    },
  ];
  return {searchOptions};
};
